module.exports = __webpack_public_path__ + "b4827e48376f01a1865e5b3de87f7115.png";